<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="ch00_part01"><a id="page_7"></a><span class="small">ONE</span> 1889-1900<a id="page_8"></a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_part01.vue?6dead7dc